import React, { useContext } from "react";
import { AuthContext, AuthProvider } from "./contexts/AuthContext";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Candidates from "./pages/Candidates";
import Jobs from "./pages/Jobs";
import Interviews from "./pages/Interviews";
import Reports from "./pages/Reports";
import CandidateReport from "./pages/CandidateReport";
import ProtectedRoute from "./components/ProtectedRoute";
import OrganizationManagement from "./pages/OrganizationManagement";
import OrganizationUsers from './pages/OrganizationUsers';
import 'antd/dist/reset.css'; // for AntD v5
import JobApplicants from "./pages/JobApplicants";
import UserProfile from "./pages/UserProfile"; // ← add this import


// Allowed roles for report access
const REPORT_ROLES = ["superadmin", "admin", "hr", "hiring_manager"];

// Generic role guard using group_role (your app standard)
function RequireRole({ roles, children }) {
  const { user } = useContext(AuthContext);
  const role = user?.group_role;
  const ok = role && roles.includes(role);
  if (!ok) return <div>403 Forbidden</div>;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />

          {/* Private */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/candidates"
            element={
              <ProtectedRoute>
                <Candidates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs"
            element={
              <ProtectedRoute>
                <Jobs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/interviews"
            element={
              <ProtectedRoute>
                <Interviews />
              </ProtectedRoute>
            }
          />

          {/* Reports list - restricted to org admin/hr/hiring_manager/superadmin */}
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <RequireRole roles={REPORT_ROLES}>
                  <Reports />
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* Single report - protected, param-based so it always loads via auth */}
          <Route
            path="/candidate-report/:reportId"
            element={
              <ProtectedRoute>
                <RequireRole roles={REPORT_ROLES}>
                  <CandidateReport />
                </RequireRole>
              </ProtectedRoute>
            }
          />

          {/* Organizations management:
              superadmin: all orgs
              admin: only own org (page already scopes on the client) */}
          <Route
            path="/organizations"
            element={
              <ProtectedRoute>
                <RequireRole roles={["superadmin", "admin"]}>
                  <OrganizationManagement />
                </RequireRole>
              </ProtectedRoute>
            }
          />

          <Route
            path="/org-users"
            element={
              <ProtectedRoute>              
                <OrganizationUsers />
              </ProtectedRoute>
            } />

          <Route
            path="/jobs/:jobId/applicants"
            element={
              <ProtectedRoute>              
                <JobApplicants />
              </ProtectedRoute>
            } />

          <Route
            path="/profile"
            element={
              <UserProfile />
            } />

              
        </Routes>

      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
